var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgCircleEstimatePhotos(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.75 11.977c0-3.47-1.875-6.657-4.875-8.438-3.047-1.734-6.75-1.734-9.75 0C7.078 5.32 5.25 8.508 5.25 11.977c0 3.515 1.828 6.703 4.875 8.484 3 1.734 6.703 1.734 9.75 0 3-1.781 4.875-4.969 4.875-8.484zm-21.75 0a11.91 11.91 0 016-10.36c3.703-2.156 8.25-2.156 12 0 3.703 2.156 6 6.094 6 10.36 0 4.312-2.297 8.25-6 10.406-3.75 2.156-8.297 2.156-12 0-3.75-2.156-6-6.094-6-10.406zm9-4.5c0-.829.576-1.5 1.286-1.5h6.428c.71 0 1.286.671 1.286 1.5v4.5c0 .828-.576 1.5-1.286 1.5h-6.428c-.71 0-1.286-.672-1.286-1.5v-4.5zM9.893 7.29l-.123.983c-.013.107-.02.217-.02.328v4.5a2.625 2.625 0 002.625 2.625h7.5c.111 0 .221-.007.328-.02l.984-.122-.656.742a4.864 4.864 0 01-3.656 1.65h-4.5A4.875 4.875 0 017.5 13.101v-1.5c0-1.456.639-2.763 1.65-3.656l.743-.655z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgCircleEstimatePhotos);
export default ForwardRef;
